import React, { ComponentProps } from 'react';
import Typography from 'antd/es/typography';
import clsx from 'clsx';

import './OpTitle.scss';

const { Title } = Typography;

export const OpTitle = ({
  className,
  children,
  ...titleProps
}: ComponentProps<typeof Title>) => {
  return (
    <Title className={clsx('op-title', className)} {...titleProps}>
      {children}
    </Title>
  );
};
